<template>
  <modal v-model="model" persistent max-width="600">
    <template #title>
      <template v-if="!processing">
        Uploading EndNote files...
      </template>
      <template v-else>Processing EndNote files...</template>
    </template>
    <template #content>
      <v-row no-gutters justify="center" class="my-4">
        <v-progress-circular
          :size="85"
          indeterminate
          color="grey darken-2"
        >
          <template v-if="!processing">{{ totalProgress }}%</template>
        </v-progress-circular>
      </v-row>
      <template v-if="!processing">
        <v-row no-gutters justify="center" class="mb-4">
          <v-progress-linear
            v-if="!xmlFileComplete"
            :value="xmlFileProgress"
            height="25"
            color="primary"
            rounded
          >
            <span>{{ xmlFileName }}</span>
          </v-progress-linear>
          <div v-else>
            <v-icon color="success">check_circle</v-icon>
            {{ xmlFileName }} successfully uploaded!
          </div>
        </v-row>
        <v-row no-gutters justify="center">
          <v-progress-linear
            :value="zipFileProgress"
            height="25"
            color="primary"
            rounded
          >
            {{ zipFileName }}
          </v-progress-linear>
        </v-row>
      </template>
      <v-row
        v-else
        no-gutters
        justify="center"
        class="caption grey--text text--darken-2"
      >
        Processing EndNote files... this may take a few minutes.
      </v-row>
    </template>
    <template #actions>
      <action-button @click="$emit('cancel')">Cancel</action-button>
    </template>
  </modal>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import Modal from '@/components/Common/Modal';

export default {
  name: 'BulkUploadProgressDialog',
  components: { ActionButton, Modal },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    xmlFileName: {
      type: String,
      default: null,
    },
    zipFileName: {
      type: String,
      default: null,
    },
    xmlFileProgress: {
      type: Number,
      default: 0,
    },
    zipFileProgress: {
      type: Number,
      default: 0,
    },
    processing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    xmlFileComplete() {
      return this.xmlFileProgress === 100;
    },
    zipFileComplete() {
      return this.zipFileProgress === 100;
    },
    totalProgress() {
      const xmlFileProgress = Number.isFinite(this.xmlFileProgress)
        ? this.xmlFileProgress
        : 0;
      const zipFileProgress = Number.isFinite(this.zipFileProgress)
        ? this.zipFileProgress
        : 0;
      let progress = xmlFileProgress + zipFileProgress;
      progress = (progress / 200) * 100;
      return Math.round(progress);
    },
  },
};
</script>
